import "./CenterSection.css";

const CenterSection = () => {
    return (
        <section className="center-section">

            <div className="center-content">

                <h2>
                    Miramos hacia el futuro con determinación
                </h2>

                <p>
                    Gracias a la visión de Oscar Fredy González Rivera, hoy Vemasmas es sinónimo de innovación, estrategia y transformación digital.
                </p>

                <p>
                    Porque en Vemasmas, no solo imaginamos el futuro: lo diseñamos, lo programamos y lo ponemos en marcha todos los días.
                </p>

            </div>

        </section>
    );
};

export default CenterSection;
